// @flow

import viewer from './viewer';
import model from './model';
import segmentation from './segmentation';

export default {
  viewer,
  model,
  segmentation,
};
